// The agent slot a project page is viewing (docs/Y2026-Q4/design-agent-configs.md
// section 11). Kept apart from AgentSlotProvider so that file exports only a component.
import { createContext, useContext } from "react";

export const DEFAULT_SLOT = "default";

export interface AgentSlotScope {
  projectId: string;
  slot: string;
}

// Null outside a project page: cross-project pages read the default slot only.
export const AgentSlotContext = createContext<AgentSlotScope | null>(null);

export const useAgentSlot = (): string =>
  useContext(AgentSlotContext)?.slot ?? DEFAULT_SLOT;

/** The request body with the slot in view added. A call that names its own `config`, or
 * names a project other than the one in view, is left as it is: that slot may not exist
 * on the other project. */
export const withSlot = (body: unknown, scope: AgentSlotScope | null): unknown => {
  if (scope === null || scope.slot === DEFAULT_SLOT) return body;
  if (body !== undefined && (typeof body !== "object" || body === null || Array.isArray(body))) {
    return body;
  }
  const fields = (body ?? {}) as Record<string, unknown>;
  if ("config" in fields) return body;
  if (fields.project_id !== undefined && fields.project_id !== scope.projectId) return body;
  const ids = fields.project_ids;
  if (Array.isArray(ids) && ids.some((id) => id !== scope.projectId)) return body;
  return { ...fields, config: scope.slot };
};
